import { render } from "./Controles.vue?vue&type=template&id=3e446238&scoped=true"
import script from "./Controles.vue?vue&type=script&lang=js"
export * from "./Controles.vue?vue&type=script&lang=js"

import "@/assets/css/tabs.css?vue&type=style&index=0&id=3e446238&scoped=true&lang=css"
import "./Controles.vue?vue&type=style&index=1&id=3e446238&scoped=true&lang=css"

import exportComponent from "C:\\Software\\Aplicaciones\\allikamay\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3e446238"]])

export default __exports__